import React from 'react'

export default function SkillItems(props) {
    const skillTrimed=(props.data.name.toLowerCase()).replace(" ","");
  return (
    <>
        <div className="skill-progress">
                    <div className={skillTrimed+'-skill'} data-skill-level={props.data.level} style={{width:props.data.level+"%"}}>
                        <span className="skill-name">{props.data.name}</span>
                    </div>
        </div>
    </>
  )
}
